// src/services/AIRecommendationService.js
class AIRecommendationService {
  constructor() {
    this.userBehavior = this.loadUserBehavior();
  }

  loadUserBehavior() {
    const saved = localStorage.getItem('userBehavior');
    return saved ? JSON.parse(saved) : {
      viewHistory: [],
      wishlist: [],
      categories: {},
      arUsage: []
    };
  }

  trackProductView(productId, category, duration) {
    const interaction = {
      productId,
      category,
      duration,
      timestamp: Date.now(),
      type: 'view'
    };

    this.userBehavior.viewHistory.push(interaction);
    this.updateCategoryPreference(category, duration);
    this.saveUserBehavior();
  }

  trackARUsage(productId) {
    this.userBehavior.arUsage.push({
      productId,
      timestamp: Date.now()
    });
    this.saveUserBehavior();
  }

  trackWishlist(productId, action) {
    if (action === 'add' && !this.userBehavior.wishlist.includes(productId)) {
      this.userBehavior.wishlist.push(productId);
    } else if (action === 'remove') {
      this.userBehavior.wishlist = this.userBehavior.wishlist.filter(id => id !== productId);
    }
    this.saveUserBehavior();
  }

  updateCategoryPreference(category, duration) {
    if (!this.userBehavior.categories[category]) {
      this.userBehavior.categories[category] = 0;
    }
    this.userBehavior.categories[category] += duration;
  }

  getRecommendations(allProducts, currentProductId = null, limit = 6) {
    const scores = allProducts.map(product => ({
      ...product,
      score: this.calculateRecommendationScore(product, currentProductId)
    }));

    return scores
      .filter(p => p.id !== currentProductId)
      .sort((a, b) => b.score - a.score)
      .slice(0, limit);
  }

  calculateRecommendationScore(product, currentProductId) {
    let score = 0;

    const categoryWeight = this.userBehavior.categories[product.category] || 0;
    score += categoryWeight * 0.4;

    const viewCount = this.userBehavior.viewHistory.filter(
      v => v.productId === product.id
    ).length;
    score += viewCount * 10 * 0.25;

    if (this.userBehavior.wishlist.includes(product.id)) {
      score += 100 * 0.2;
    }

    const arUsage = this.userBehavior.arUsage.filter(
      a => a.productId === product.id
    ).length;
    score += arUsage * 15 * 0.15;

    const recentViews = this.userBehavior.viewHistory
      .filter(v => v.productId === product.id && Date.now() - v.timestamp < 86400000)
      .length;
    score += recentViews * 5;

    if (currentProductId) {
      const currentProduct = this.userBehavior.viewHistory.find(
        v => v.productId === currentProductId
      );
      if (currentProduct && currentProduct.category === product.category) {
        score += 30;
      }
    }

    return score;
  }

  saveUserBehavior() {
    localStorage.setItem('userBehavior', JSON.stringify(this.userBehavior));
  }

  getUserInsights() {
    const topCategories = Object.entries(this.userBehavior.categories)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 3)
      .map(([category, time]) => ({ category, time }));

    return {
      totalViews: this.userBehavior.viewHistory.length,
      topCategories,
      wishlistCount: this.userBehavior.wishlist.length,
      arUsageCount: this.userBehavior.arUsage.length
    };
  }
}

export default new AIRecommendationService();
